<template>
  <v-dialog v-model="dialog" width="500" :fullscreen="$vuetify.breakpoint.smAndDown">
    <template v-slot:activator="{ on }">
      <v-btn color="primary" v-on="on"> <v-icon left>add</v-icon>{{ addButtonText }} </v-btn>
    </template>
    <v-card>
      <v-card-title class="amber darken-1 white--text"
        >Thêm mới Showcase
        <v-spacer />
        <v-icon color="white" @click="cancel">close</v-icon>
      </v-card-title>
      <v-divider></v-divider>
      <showcase-info-form ref="form" />
      <v-card-actions class="pr-4 pb-8">
        <v-spacer />
        <v-btn class="px-4" color="primary" @click="save" :loading="loading">Lưu</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import ShowcaseInfoForm from '@/components/basic/form/ShowcaseForm.vue'
import { mapActions, mapState, mapGetters } from 'vuex'

export default {
  components: {
    ShowcaseInfoForm
  },
  props: {
    state: Boolean,
    major: Object,
    course: Object
  },
  data() {
    return {
      dialog: false,
      loading: false
    }
  },
  computed: {
    ...mapState('app', ['roles', 'department']),
    ...mapState('auth', ['user']),

    addButtonText() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
        case 'sm':
          return 'Thêm'
        default:
          return 'Thêm Mới Showcase'
      }
    }
  },
  methods: {
    ...mapActions('showcases', ['createShowcase', 'upload', 'fetchShowcases']),
    async save() {
      this.loading = true
      let form = this.$refs.form
      let data = form.getData()
      if (form.validate()) {
        let showcase = await this.createShowcase({
          ...data,
          data: { link: data.embed }
        })
        await this.upload({
          showcaseId: showcase.id,
          file: data.file
        })
        await this.fetchShowcases({})
        this.dialog = false
        this.$refs.form.reset()
      }
      this.loading = false
    },
    cancel() {
      this.$refs.form.reset()
      this.dialog = false
    }
  },
  watch: {
    state(state) {
      this.dialog = true
    }
  }
}
</script>
